import React from "react";
import {
  Button,
  Grid,
} from "@mui/material";
import type { ExportType, PageTypes } from "./types/ExportPageFd.types";
import FormDialog from "../FormDialog";
import type { Page } from "../../reducers/exportPage/reducer";

interface Props {
  open?: boolean;
  exporting?: boolean;
  page: Page;
  onApply: (type: ExportType, ids: Array<string>, pageType: PageTypes) => void;
  onClose: () => void;
}

function ExportPageFd({
  open = false,
  exporting = false,
  page,
  onApply,
  onClose,
}: Props) {
  const {
    id: pageId,
    name: pageName,
    type: pageType,
  } = page || {};
  let ids: Array<string> = [];
  const resetDialog = () => {
    ids = [];
  };
  const handleClose = () => {
    onClose();
    resetDialog();
  };
  const handleApply = (type: ExportType) => {
    onApply && onApply(type, [...ids], pageType);
    resetDialog();
  };

  if (pageId) {
    ids.push(pageId);
  }

  return (
    <FormDialog
      open={open}
      loading={exporting}
      title={`Export Page ${pageName}`}
      hideApply
      onClose={handleClose}
    >
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
        width={1}
      >
        {pageType === "pft" && (
          <Grid size={6}>
            <Button
              id="csv-button"
              data-testid="csv-type-button"
              variant="contained"
              fullWidth
              onClick={() => handleApply("csv")}
            >
              CSV
            </Button>
          </Grid>
        )}
        {pageType !== "pft" && (
          <Grid size={6}>
            <Button
              id="archive-button"
              data-testid="archive-type-button"
              variant="contained"
              fullWidth
              onClick={() => handleApply("zip")}
            >
              Archive
            </Button>
          </Grid>
        )}
      </Grid>
    </FormDialog>
  );
}

export default ExportPageFd;
